// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__12b4p","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__3iKvK"};